import React from 'react';
import { EVUserOutlinedIcon } from '@eagleview/ev-comp-library';
import useStyles from '../UserProfileStyle';

const BadgeContent = () => {
  const classes = useStyles();

  return (
    <div id="badge-container" className={classes.badgeContainer}>
      <EVUserOutlinedIcon className={classes.badgeIcon} />
    </div>
  );
};

export default BadgeContent;
